import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import { MainSectionLayout, TabProps } from '@Components/index';
import GeneralSettingsLayout from '@Containers/Settings/AdminSettings/GeneralSettingsLayout';
import StateTsr from '@Containers/Settings/AdminSettings/StateTsr';

const AdminSettingsMain: FunctionComponent = (): JSX.Element => {
  const { t } = useTranslation();

  const headingText = t('adminSettings.Admin Settings');

  const getTabProps = (): TabProps => ({
    labels: [t('adminSettings.General Settings'), t('adminSettings.State TSR')],
    values: [<GeneralSettingsLayout />, <StateTsr />],
  });

  return (
    <>
      <MainSectionLayout heading={headingText} tabProps={getTabProps()} />
    </>
  );
};

export default AdminSettingsMain;
